import { useGetAllTypesQuery } from '../../api/api-hooks';
import FilterBar from '../../components/FilterBar';
import { CircularProgress, TextField, Typography } from '@mui/material';
import { Filters } from './inventoryTypes';
import { filterConstraintChecker } from './inventoryHardwareUtils';
import ToggleSwitch from '../../components/ToggleSwitch';
import { useHistory } from 'react-router-dom';
import { Autocomplete } from '@mui/material';

interface Props {
  filters: Filters;
  setFilters: React.Dispatch<any>;
  initialFilters: Filters;
}

const InventoryHardwareFilterBar = ({
  filters,
  setFilters,
  initialFilters,
}: Props) => {
  const { data: analyzerTypes } = useGetAllTypesQuery({});
  const history = useHistory();
  if (analyzerTypes === undefined) return <CircularProgress></CircularProgress>;

  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <ToggleSwitch
            options={['Hardware', 'Parts']}
            onClicks={[
              () => {
                history.push('/inventory/hardware');
              },
              () => {
                history.push('/inventory/parts');
              },
            ]}
            startingOption='Hardware'
          />,
          <TextField
            name='serial'
            value={filters.serial}
            onChange={handler}
            label='Filter By Serial'
            variant='outlined'
          ></TextField>,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'hardwareType');
            }}
            value={filters.hardwareType}
            options={analyzerTypes}
            getOptionLabel={(type) => type.typeName}
            style={{ width: 200 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Type'
                variant='outlined'
              />
            )}
          />,

          <Typography>From:</Typography>,
          <TextField
            name='fromDateFilter'
            variant='outlined'
            type='date'
            value={filters.fromDateFilter}
            onChange={handler}
          />,
          <Typography>To:</Typography>,
          <TextField
            name='toDateFilter'
            variant='outlined'
            type='date'
            value={filters.toDateFilter}
            onChange={handler}
          />,
        ]}
      />
    </>
  );
};

export default InventoryHardwareFilterBar;
